export const TOKEN_KEY = 'token'
export const ENV_PROD = 'PROD'
export const ENV_DEV = 'DEV'
export const ENV_TEST = 'TEST'
export const LOGIN_TYPE = 'login_type'
export const LOGIN_ROLE = 'login_role'